// hooks/useLocalization.js
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
// import {
//   selectIsVoiceFlow,
//   selectSelectedSocketLanguageData,
//   selectTextLanguageDetectionData,
//   selectVoiceFlowLocks,
// } from "../store/features/message/textContentSelectors";

// import { useAppContext } from "../context/AppContext";

const useLocalization = () => {
  const { t, i18n } = useTranslation();
  // const selectedSocketLanguageData = useSelector(
  //   selectSelectedSocketLanguageData
  // );
  // const langDetectData = useSelector(selectTextLanguageDetectionData);
  // const isVoiceFlow = useSelector(selectIsVoiceFlow);
  // const isVoiceFlowLocked = useSelector(selectVoiceFlowLocks);
  // const { selectedLanguageData } = useAppContext();

  // ✅ Memoize setLanguage to prevent infinite loops
  const setLanguage = useCallback(
    (languageCode) => {
      if (i18n.language !== languageCode) {
        i18n.changeLanguage(languageCode);
      }
    },
    [i18n]
  );

  // ✅ Memoize getLanguage
  const getLanguage = useCallback(() => {
    return i18n.language;
  }, [i18n.language]);

  return {
    t,
    setLanguage,
    getLanguage,
  };
};

export default useLocalization;
